import PropTypes from 'prop-types'
import kebabCase from 'lodash/kebabCase'
import { useTranslation } from 'react-i18next'
import { TableOfContents } from './components'
import * as styles from './CalculatorSectionModule.module.scss'
import { Heading } from '../../typography/Heading'
import { Container, Row, Col } from '../../grid'
import { RichText } from '../../rich-text'
import { CalculatorModule } from '../../calculators/CalculatorModule'

const CalculatorSectionModule = ({
  pageTitle,
  anchorLinkSections,
  calculator,
  sections,
  calcTips,
}) => {
  const [t] = useTranslation()

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <Heading className={styles.LegalHeading} element="h1" size={2}>
            {pageTitle}
          </Heading>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={3}>
          <TableOfContents pageTitle={pageTitle} anchorLinkSections={anchorLinkSections} />
        </Col>
        <Col xs={12} md={9}>
          {sections.map(section => {
            /* Eliminate all whitespace from the title string and use that as the anchor ID */
            const sectionId = kebabCase(section.sectionTitle)
            return (
              <div
                key={`key-${sectionId}`}
                className={styles.Section}
                id={sectionId}
                data-qa="calculator-module-section"
              >
                <Heading element="h2" size={3}>
                  {section.sectionTitle}
                </Heading>
                <RichText listType="default">{section.richBody}</RichText>
                {calcTips && (
                  <div className={styles.CalcTips}>
                    <Heading element="h3" size={3}>
                      {t('CalculatorSectionModule.tipsForUsingThisCalculator', {
                        defaultValue: 'Tips for using this calculator',
                      })}
                    </Heading>
                    {calcTips}
                  </div>
                )}
              </div>
            )
          })}
          <div
            className={(styles.Section, styles.TableSection)}
            data-qa="calculator-module-section"
          >
            <CalculatorModule calculator={calculator} />
          </div>
        </Col>
      </Row>
    </Container>
  )
}

CalculatorSectionModule.propTypes = {
  pageTitle: PropTypes.string,
  sections: PropTypes.arrayOf(PropTypes.object),
  anchorLinkSections: PropTypes.arrayOf(PropTypes.object),
  calculator: PropTypes.object,
  calcTips: PropTypes.object,
}

export { CalculatorSectionModule }
export default CalculatorSectionModule
